import { Link } from 'react-router-dom';

export default function CheckoutSuccess() {
  return (
    <div style={{
      color: 'white',
      minHeight: '80vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center',
      gap: '16px',
      padding: '40px 20px',
    }}>
      <p style={{ fontSize: '0.85rem', letterSpacing: '0.1em', textTransform: 'uppercase', opacity: 0.5, margin: 0 }}>
        Payment Complete
      </p>
      <h1 style={{ fontSize: '2rem', margin: 0 }}>You're in.</h1>
      <p style={{ opacity: 0.45, maxWidth: '380px', lineHeight: 1.7, fontSize: '0.9rem', margin: 0 }}>
        Your order is confirmed. You'll receive an email receipt shortly.
        We'll be in touch with next steps.
      </p>
      <Link
        to="/"
        style={{
          marginTop: '16px',
          color: 'white',
          border: '1px solid #555',
          padding: '12px 28px',
          fontSize: '0.85rem',
          letterSpacing: '0.08em',
          textDecoration: 'none',
        }}
      >
        Back to Home
      </Link>
    </div>
  );
}
